// export const API_URL = 'http://51.15.145.149:8081/'
//export const API_URL = "http://95.169.205.142:9000/"; 
//export const API_URL = "https://mycanalolympia.dotbmedia.com/api/";
export const API_URL = "https://api.canalolympia.com/api/";
// export const API_URL = 'http://62.210.5.214:9000/'
// export const API_URL = 'http://62.210.136.219:8802/api'
// export const API_URL = 'http://192.168.1.101:8000/api'
// export const API_URL = 'http://192.168.100.111:8001/api'
// export const API_URL = 'http://172.104.62.74:3305/api'
// export const API_URL = 'https://sica-test2.netlify.app/api'
// export const API_URL = 'https://sicas-api.anpe.bj/api'
// export const SOCKET_URL = 'ws://localhost:8000'
// export const API_URL = 'http://62.210.5.214:12081/api'

export const FILE_UPLOAD_API_URL = API_URL + 'cdn/images'
export const FILE_UPLOAD_API_URL_ONE = API_URL + 'cdn/files/upload';
export const FILE_GET_URL = API_URL +'/cdn/upload/';

export const paginationParamNames = {
  page: 'page',
  rowsPerPage: 'size',
  totalCount: 'totalElements',
  pageCount: 'totalPages',
  sortBy: 'sort'
}

// Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZS5nb2dvdW5vdS42OTMwMjMwOUBhZS5hbnBlLmJqIiwicm9sZXMiOlsiUk9MRV9BRSJdLCJ1c2VybmFtZSI6ImFlLmdvZ291bm91LjY5MzAyMzA5QGFlLmFucGUuYmoiLCJpYXQiOjE2NDg4MjQzMTUsImV4cCI6MTY0OTEyNDMxNX0.nQ9aQvpuM0R_CyClUEUku_BPKtI-mPJAxZbF-4B2CFc